export const participantLegalName = (lotOrParticipant) => {
  if (!lotOrParticipant) {
    return null;
  }
  if (typeof lotOrParticipant.legalName === "string") {
    return lotOrParticipant.legalName;
  }
  return lotOrParticipant.participant?.legalName ?? null;
};

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

/**
 * Map a single search box value to one backend filter param.
 * - 11/14 digits or 14-character alphanumeric CNPJ → documentNumber (exact)
 * - name-like (spaces, or letters without id separators) → legalName (prefix)
 * - otherwise → participantId (exact), including opaque ids / UUIDs
 */
export const resolveParticipantSearch = (query) => {
  const trimmed = query == null ? "" : String(query).trim();
  if (!trimmed) {
    return {};
  }

  const digits = digitsOnly(trimmed);
  const hasLetter = /[A-Za-zÀ-ÿ]/.test(trimmed);
  const hasWhitespace = /\s/.test(trimmed);
  const canonicalDocument = trimmed.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  const looksLikeAlphanumericCnpj = canonicalDocument.length === 14 && /[A-Z]/.test(canonicalDocument) && /\d/.test(canonicalDocument);
  const looksLikeOpaqueId = /[-_]/.test(trimmed) || /[0-9]/.test(trimmed);

  if (!hasLetter && (digits.length === 11 || digits.length === 14)) {
    return { documentNumber: digits };
  }
  if (looksLikeAlphanumericCnpj) {
    return { documentNumber: canonicalDocument };
  }
  if (hasLetter && (hasWhitespace || !looksLikeOpaqueId)) {
    return { legalName: trimmed };
  }
  return { participantId: trimmed };
};

export const describeParticipantFilter = (filter = {}) => {
  if (filter.legalName) {
    return { label: "nome", value: filter.legalName };
  }
  if (filter.documentNumber) {
    return { label: "documento", value: filter.documentNumber };
  }
  if (filter.participantId) {
    return { label: "ID", value: filter.participantId };
  }
  return null;
};

export const participantFilterKey = (filter = {}) =>
  JSON.stringify({
    participantId: filter.participantId || null,
    legalName: filter.legalName || null,
    documentNumber: filter.documentNumber || null,
  });

/** Full balance-lot list filter key (cadastral + credited date range). */
export const balanceLotFilterKey = (filter = {}) =>
  JSON.stringify({
    participantId: filter.participantId || null,
    legalName: filter.legalName || null,
    documentNumber: filter.documentNumber || null,
    creditedFrom: filter.creditedFrom || null,
    creditedTo: filter.creditedTo || null,
  });

export const pickParticipantFilter = (filter = {}) => {
  const next = {};
  if (filter.participantId) next.participantId = filter.participantId;
  if (filter.legalName) next.legalName = filter.legalName;
  if (filter.documentNumber) next.documentNumber = filter.documentNumber;
  return next;
};

export const pickCreditedDateFilter = (filter = {}) => {
  const next = {};
  if (filter.creditedFrom) next.creditedFrom = filter.creditedFrom;
  if (filter.creditedTo) next.creditedTo = filter.creditedTo;
  return next;
};
